module.exports = __webpack_public_path__ + "img/Feature.c2795855.png";